var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inactiveBadge)?_c('gl-badge',{attrs:{"variant":_vm.inactiveBadge.variant}},[_vm._v(_vm._s(_vm.inactiveBadge.text))]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }